import { pageSize } from "../constant";
import { PageType } from "./Enum";
import { ListResponse } from "./ResponseModel";



export class  Page_SearchRequest 
{
    URL: string | null;
    PageID: number | null;
    PageTypeID: PageType | null;

}

export class PageSummary_SearchRequest  extends ListResponse
{
    URL: string | null;
    PageID: number | null;
    PageTypeID: PageType | null;
    ParentPageID: number | null;
}


export class  StoreLocatorReqData {
    cityID : number | null;
    stateID : number | null;
    lat : number | null;
    lng : number | null;
    pincode : string | null;
    CompanyID : number | null;
    range : number | null
    pageNumber = 1;
    pageSize = pageSize;
    storeName : string | null;
    ProductID : number | null;
    OnlyMangoes : boolean | false;
    searchByStore : number | false;
    searchByCompany : number | false;
}